import { render } from "./PdvDateFilter.vue?vue&type=template&id=0b22b7ca&scoped=true"
import script from "./PdvDateFilter.vue?vue&type=script&lang=js"
export * from "./PdvDateFilter.vue?vue&type=script&lang=js"

import "./PdvDateFilter.vue?vue&type=style&index=0&id=0b22b7ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b22b7ca"]])

export default __exports__